 (function(){
  /* ---------- nav stuck state ---------- */
  var nav = document.getElementById('nav');
  var lastY = 0;
  window.addEventListener('scroll', function(){
    var y = window.scrollY;
    if(nav){
      nav.classList.toggle('stuck', y > 8);
      // hide when scrolling down (past the hero top), show when scrolling up
      if(y > 120 && y > lastY) nav.classList.add('hidden');
      else nav.classList.remove('hidden');
    }
    lastY = y;
  }, {passive:true});

  /* ---------- reveal on scroll ---------- */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  }, {threshold:0.18});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  /* ---------- build falling snack bits ---------- */
  var fall = document.getElementById('fall');
  var bits = [];
  if(fall){
    var classes = ['o','g','o','g','o'];
    for(var i=0;i<26;i++){
      var b = document.createElement('span');
      b.className = 'bit ' + classes[i % classes.length];
      var startX = 46 + Math.random()*8;        // start near pouch mouth (%)
      var endX = 30 + Math.random()*40;          // spread into bowl (%)
      var delay = Math.random();                 // 0..1 progress offset
      b.dataset.sx = startX; b.dataset.ex = endX; b.dataset.delay = delay;
      b.style.left = startX + '%';
      fall.appendChild(b);
      bits.push(b);
    }
  }

  /* ---------- interactive comparison ---------- */
  var DATA = {
    protein:  {unit:'Grams of protein per 100g · more is better', better:'high', max:50,
               v:{promunch:42.6, makhana:9.5, chips:24, peanuts:25.8}},
    fibre:    {unit:'Grams of fibre per 100g · more is better', better:'high', max:16,
               v:{promunch:10.5, makhana:14.5, chips:7.5, peanuts:8.5}},
    calories: {unit:'Calories per 100g · less is better', better:'low', max:650,
               v:{promunch:230, makhana:356, chips:360, peanuts:567}},
    fat:      {unit:'Grams of fat per 100g · less is better', better:'low', max:52,
               v:{promunch:0.5, makhana:1.2, chips:13.5, peanuts:49.2}}
  };
  var rows = document.querySelectorAll('#cmpRows .cmp-row');
  var unitEl = document.getElementById('cmpUnit');
  var multiEl = document.getElementById('cmpMulti');
  var capEl = document.getElementById('cmpCap');
  var badgeEl = document.getElementById('cmpBadge');
  var TEX = {
    promunch:'../assets/cmp-promunch.jpg',
    makhana:'../assets/cmp-makhana.jpg',
    chips:'../assets/cmp-proteinbar.jpg',
    peanuts:'../assets/cmp-peanuts.jpg'
  };
  rows.forEach(function(r){
    var fill = r.querySelector('.cmp-fill');
    var tex = document.createElement('div');
    tex.className = 'cmp-tex';
    tex.style.backgroundImage = 'url("' + TEX[r.dataset.key] + '")';
    fill.insertBefore(tex, fill.firstChild);
  });
  function sizeTex(){
    rows.forEach(function(r){
      var track = r.querySelector('.cmp-track');
      var tex = r.querySelector('.cmp-tex');
      if(track && tex) tex.style.width = track.clientWidth + 'px';
    });
  }
  var CAP = {
    protein:{n:42.6,c:24,word:'more protein than a protein bar'},
    fibre:{n:10.5,c:7.5,word:'more fibre than a protein bar'},
    calories:{n:360,c:230,word:'fewer calories than a protein bar'},
    fat:{n:13.5,c:0.5,word:'less fat than a protein bar'}
  };
  function tween(el,to,unit){
    var from=0,start=null,dur=700;
    function step(ts){
      if(!start)start=ts;
      var p=Math.min(1,(ts-start)/dur);
      var e=1-Math.pow(1-p,3);
      var v=from+(to-from)*e;
      el.textContent=(to%1!==0?v.toFixed(1):Math.round(v))+unit;
      if(p<1)requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function paint(metric){
    var d = DATA[metric];
    if(unitEl) unitEl.textContent = d.unit;
    sizeTex();
    // dynamic hero multiplier vs potato chips
    var c = CAP[metric];
    var mult = (c.n/c.c);
    if(multiEl) tween(multiEl, mult, '×');
    if(capEl) capEl.textContent = c.word;
    // winner badge: only when Promunch leads the metric
    var vals = Object.keys(d.v).map(function(k){return d.v[k];});
    var pv = d.v.promunch;
    var wins = (d.better==='high') ? (pv >= Math.max.apply(null,vals)) : (pv <= Math.min.apply(null,vals));
    if(badgeEl) badgeEl.classList.toggle('hide', !wins);
    rows.forEach(function(r){
      var key = r.dataset.key;
      var val = d.v[key];
      var pct = Math.max(4, Math.min(100, (val/d.max)*100));
      var fill = r.querySelector('.cmp-fill');
      var label = r.querySelector('.cmp-val');
      fill.style.width = pct + '%';
      var unit = (metric==='calories') ? ' kcal' : 'g';
      tween(label, val, unit);
    });
  }
  window.addEventListener('resize', sizeTex);
  var tabs = document.querySelectorAll('#cmpTabs button');
  tabs.forEach(function(b){
    b.addEventListener('click', function(){
      tabs.forEach(function(x){x.classList.remove('on');});
      b.classList.add('on');
      paint(b.dataset.metric);
    });
  });
  // paint protein once the section reveals (so bars animate from 0)
  var cmpSection = document.getElementById('compare');
  if(cmpSection){
    var pio = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ paint('protein'); pio.disconnect(); }});
    }, {threshold:0.3});
    pio.observe(cmpSection);
  }

  /* ---------- duplicate UGC lane for seamless loop ---------- */
  var lane = document.getElementById('ugcLane');
  if(lane){ lane.innerHTML += lane.innerHTML; }

/* ---------- Tweaks: Gen-Z typeface picker ---------- */
(function(){
  var TWEAKS = /*EDITMODE-BEGIN*/{"fontset":"archivo"}/*EDITMODE-END*/;
  var FONTSETS = {
    archivo:   {label:'Archivo Black + Assistant', disp:"'Archivo Black',sans-serif",   body:"'Assistant',system-ui,sans-serif"},
    sora:      {label:'Sora + Inter',              disp:"'Sora',sans-serif",            body:"'Inter',system-ui,sans-serif"},
    poppins:   {label:'Poppins + Work Sans',       disp:"'Poppins',sans-serif",         body:"'Work Sans',system-ui,sans-serif"},
    fraunces:  {label:'Fraunces + Manrope',        disp:"'Fraunces',serif",             body:"'Manrope',system-ui,sans-serif"},
    jost:      {label:'Jost + DM Sans',            disp:"'Jost',sans-serif",            body:"'DM Sans',system-ui,sans-serif"},
    playfair:  {label:'Playfair Display + Poppins',disp:"'Playfair Display',serif",     body:"'Poppins',system-ui,sans-serif"},
    anton:     {label:'Anton + Work Sans',         disp:"'Anton',sans-serif",           body:"'Work Sans',system-ui,sans-serif"}
  };
  function applyFont(key){
    var f = FONTSETS[key] || FONTSETS.bold;
    document.documentElement.style.setProperty('--fdisp', f.disp);
    document.documentElement.style.setProperty('--fbody', f.body);
  }
  applyFont(TWEAKS.fontset);

  /* sliding-highlight nav */
  (function () {
  var wrap = document.getElementById("navLinks");
  var hl = document.getElementById("navHl");

  if (!wrap || !hl) return;

  var items = wrap.querySelectorAll(".header__menu-item");

  function moveTo(el) {
    var wrapRect = wrap.getBoundingClientRect();
    var rect = el.getBoundingClientRect();

    hl.style.opacity = "1";
    hl.style.width = rect.width + "px";
    hl.style.transform =
      "translateX(" + (rect.left - wrapRect.left) + "px)";
  }

  items.forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      moveTo(item);
    });
  });

  wrap.addEventListener("mouseleave", function () {
    hl.style.opacity = "0";
  });
})();

  // styles
  var st=document.createElement('style');
  st.textContent=".pm-tweaks{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:236px;background:#fff;color:#1a1714;border:1px solid rgba(0,0,0,.1);border-radius:14px;box-shadow:0 14px 44px rgba(0,0,0,.2);font-family:'JetBrains Mono',monospace;overflow:hidden}"+
    ".pm-tw-hd{display:flex;align-items:center;justify-content:space-between;padding:11px 10px 11px 14px;border-bottom:1px solid rgba(0,0,0,.08)}"+
    ".pm-tw-hd b{font-size:12px;letter-spacing:.05em;text-transform:uppercase}"+
    ".pm-tw-hd button{border:0;background:transparent;font-size:14px;cursor:pointer;color:#888;line-height:1}"+
    ".pm-tw-body{padding:13px 14px 15px;max-height:62vh;overflow-y:auto}"+
    ".pm-tw-sect{font-size:9px;letter-spacing:.16em;text-transform:uppercase;color:#9a9a9a;margin-bottom:9px}"+
    ".pm-tw-opts{display:flex;flex-direction:column;gap:7px}"+
    ".pm-fopt{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 13px;border:1.5px solid rgba(0,0,0,.12);border-radius:11px;background:#fff;cursor:pointer;color:#1a1714}"+
    ".pm-fopt .nm{font-size:18px;text-transform:uppercase;letter-spacing:-.01em;line-height:1}"+
    ".pm-fopt .tag{font-family:'JetBrains Mono',monospace;font-size:9px;letter-spacing:.12em;text-transform:uppercase;color:#aaa}"+
    ".pm-fopt.on{border-color:#AF272F;background:#FFF1EA}"+
    ".pm-fopt.on .tag{color:#AF272F}";
  document.head.appendChild(st);

  // panel
  var panel=document.createElement('div');
  panel.className='pm-tweaks'; panel.style.display='none';
  var opts=Object.keys(FONTSETS).map(function(k){
    var f=FONTSETS[k];
    return '<div class="pm-fopt" data-k="'+k+'"><span class="nm" style="font-family:'+f.disp.replace(/"/g,"&quot;")+'">Aa</span><span class="tag">'+f.label+'</span></div>';
  }).join('');
  panel.innerHTML='<div class="pm-tw-hd"><b>Tweaks</b><button id="pmTwX" aria-label="Close">✕</button></div>'+
    '<div class="pm-tw-body"><div class="pm-tw-sect">Typeface</div><div class="pm-tw-opts">'+opts+'</div></div>';
  document.body.appendChild(panel);

  function mark(){
    panel.querySelectorAll('.pm-fopt').forEach(function(el){
      el.classList.toggle('on', el.dataset.k===TWEAKS.fontset);
    });
  }
  mark();
  panel.querySelectorAll('.pm-fopt').forEach(function(el){
    el.addEventListener('click',function(){
      TWEAKS.fontset=el.dataset.k; applyFont(TWEAKS.fontset); mark();
      try{ window.parent.postMessage({type:'__edit_mode_set_keys', edits:{fontset:TWEAKS.fontset}}, '*'); }catch(e){}
    });
  });
  panel.querySelector('#pmTwX').addEventListener('click',function(){
    panel.style.display='none';
    try{ window.parent.postMessage({type:'__edit_mode_dismissed'}, '*'); }catch(e){}
  });

  window.addEventListener('message',function(e){
    var t=e&&e.data&&e.data.type;
    if(t==='__activate_edit_mode') panel.style.display='block';
    else if(t==='__deactivate_edit_mode') panel.style.display='none';
  });
  try{ window.parent.postMessage({type:'__edit_mode_available'}, '*'); }catch(e){}
})();
})();


